import { ChannelPayloadFilter, ViewStream } from "spyne";
import { pick, compose, path, isNotEmpty } from "ramda";
import { gsap } from "gsap";
import { PageLoadDocsTraits } from "traits/page-load-docs-traits";
import hljs from "highlight.js";
export class CodeContainerPropertiesContent extends ViewStream {
  constructor(props = {}) {
    props.tagName = "article";

    const isEmptyClass =
      CodeContainerPropertiesContent.propertiesAreNotEmptyBool(props.data)
        ? ""
        : "properties-empty";

    const hideSignatureClass = props?.data?.hideSignature ? 'hide-signature ' : '';

    props.class = `code-container-properties-content ${isEmptyClass} ${hideSignatureClass}`;



    //console.log("CONTENT ", props.data);

    // props.data['instxClass'] = props.data.info.instx === undefined ? "instx empty" : "instx"
    //console.log("PROPS DATA DETAILS ",props.data.info.instx,props.data.instxClass,props.data);
    // props.data['paragraphs'] = safeClone(props.data.info.body);
    props.template = require("./templates/code-container-properties-content.tmpl.html");
    super(props);
  }

  static propertiesAreNotEmptyBool(data) {
    return compose(isNotEmpty, path(["properties", 0, "propertyName"]))(data);
  }

  addActionListeners() {
    // return nexted array(s)

    const { parentVsid, codeBlockId } = this.props;
    const isContainerFilter = new ChannelPayloadFilter({
      payload: (v) => v.vsid === parentVsid,
    });
    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onChannelCodeContainerUpdateEvent",
        isCodeBlockIdFilter,
      ],
      ["CHANNEL_CODE_GEN_ANIM_COMPLETED", "onCodeHasAnimated"],
    ];
  }

  onCodeHasAnimated() {
    // gsap.set(this.props.el, {opacity:1})
    //console.log("ANIM TEXT");
    if (this.props !== undefined && this.props.el !== undefined) {
      // gsap.to(this.props.el, {opacity: 1, duration: .25, ease: "power1.inOut"})
    }
  }

  onChannelCodeContainerUpdateEvent() {
    const onCompleteExample = () => this.disposeViewStream();
    // this.props.el$.addClass('before-remove');
    const onRequestAnimOut = () => {
      if (this?.props !== undefined) {
        this.props.el.style.cssText = "position:absolute;";
        gsap.to(this.props.el, {
          opacity: 0,
          delay: 0.125,
          duration: 0.25,
          onComplete: onCompleteExample,
        });
      }
    };

    this.onSendPropertiesUpdatedPayload();

    requestAnimationFrame(onRequestAnimOut);
  }

  broadcastEvents() {
    const containsLinks = this.props.el$("a").exists;
    const broadcastEls = containsLinks ? [["a", "click"]] : [];
    return broadcastEls;
  }

  setInitialState(initialLoad = false) {
    const setOpacity = () => {
      if (this.props === undefined || this.props.el === undefined) {
        return;
      }

      initialLoad === true
        ? gsap.from(this.props.el, { opacity: 0, delay: 0.5, duration: 0.5 })
        : gsap.set(this.props.el, { opacity: 0 });
    };
    //requestAnimationFrame(setOpacity);
    setOpacity();
  }

  onSendPropertiesUpdatedPayload(isStartPosition = true) {
    const action = "CHANNEL_CODE_CONTAINER_PROPERTIES_CONTENT_ADDED";
    const channelName = "CHANNEL_CODE_CONTAINER";
    if (this?.props === undefined){
      return;
    }
    const { parentVsid, codeBlockId } = this?.props;


    const propertiesContentId = `#${this.props.el.id}`;
    const bodyEl = this.props.el$(".properties-body").el;
    const clientRect = pick(
      ["x", "y", "width", "height", "top", "bottom"],
      bodyEl.getBoundingClientRect(),
    );

    const payload = Object.assign(clientRect, {
      parentVsid,
      propertiesContentId,
      isStartPosition,
      codeBlockId,
    });
    //console.log('payload is ',payload);

    this.sendInfoToChannel(channelName, payload, action);
  }

  setOddEvenParamRows() {
    const rows$ = this.props.el$("tr.property-row");

    //console.log("ROWS IS ",rows$.arr);
    let oddIter = -1;
    const forEachRow = (el, i) => {
      oddIter = el.classList.contains("row-gray")
        ? oddIter
        : (oddIter = oddIter + 1);

      const rowClass = oddIter % 2 ? "row-even" : "row-odd";

      el.classList.add(rowClass);
    };

    if (rows$.arr.length >= 3) {
      rows$.arr.forEach(forEachRow);
    }
  }

  hideTableIfEmpty() {
    if (this.props.el$("tbody.properties.hide-empty-el").exists === true) {
      this.props.el$("table.properties").addClass("hide-empty-el");
    }

    if (
      this.props.el$("tbody.properties-return-tbody.hide-empty-el").exists ===
      true
    ) {
      this.props.el$("table.properties-return-table").addClass("hide-empty-el");
    }

    if (
      this.props.el$(".properties-header-method-params.hide-empty-el")
        .exists === true
    ) {
      this.props.el$(".properties-method-head").addClass("is-empty");
    }
  }

  checkForModalLinks(){
    function getChildSelector(baseSelector, index) {
      // CSS uses 1-based indexing, so we add 1 to the input index
      return `${baseSelector}:nth-child(${index + 1}) .td-prop-desc p a`;
    }


    const checkProperties = (obj, num)=>{

      const {modalType, promptLink, promptLinkRoute} = obj;

      if (modalType){

        const sel = getChildSelector("table.properties tbody.properties tr", num);

        const el$ = this.props.el$(sel);

        if (el$.exists){
          //console.log("MODAL IS ",{modalType, sel}, el$.el);

          const anchor = el$.el;
          anchor.dataset.btnType = 'modal';
          anchor.dataset.openModal = true;
          anchor.dataset.modalType = modalType;
          anchor.dataset.eventPreventDefault = true;




        }


      } else if (promptLink){
        const sel = getChildSelector("table.properties tbody.properties tr", num);

        const el$ = this.props.el$(sel);

        if (el$.exists){
          //console.log("PROMPT IS ",{promptLink, sel}, el$.el);

          const anchor = el$.el;
          anchor.href= promptLink;

          if (promptLinkRoute && el$.el.dataset?.channel === undefined){

            //console.log("PROMPT2 IS ",{promptLink, promptLinkRoute, sel}, el$.el);


            for (const [k,v] of Object.entries(promptLinkRoute)){
              anchor.dataset[k]=v;
            }
            anchor.dataset['channel']="ROUTE";
           // anchor.dataset['endRoute']=true;
            anchor.dataset['itemId'] = `${promptLinkRoute?.pageId}-${promptLinkRoute?.stage}`
            anchor.dataset['eventPreventDefault'] = true;
            //anchor.dataset.codeBlockDataSection = 'types';
            anchor.dataset.isMenuLink = true;

          }



        }

      }


    }

    this.props.data.properties.forEach(checkProperties);


    if (this.props.el$(".broadcast-events-modal").exists){
      //console.log("BCAST EXISTS ");
      const bcastAnchor = this.props.el$(".broadcast-events-modal").el;
      bcastAnchor.dataset.btnType = 'modal';
      bcastAnchor.dataset.openModal = true;
      bcastAnchor.dataset.modalType = 'broadcastEvents';
      bcastAnchor.dataset.eventPreventDefault = true;
    }



    //console.log("MODAL LINKS ",this.props.data);
  }

  onRendered() {
    this.setOddEvenParamRows();

    this.checkForModalLinks();

    //console.log("DETAILS INSTX IS ",this.props.data.info.instx, this.props.data.info.instx===undefined);

    this.props
      .el$(".instx")
      .toggleClass("empty", this.props.data.info.instx === undefined);

    const setInitial = () => this.setInitialState(true);
    requestAnimationFrame(setInitial);
    // setInitial();
    const frameDelayer = () => this.onSendPropertiesUpdatedPayload(false);

    requestAnimationFrame(frameDelayer);
    this.addChannel("CHANNEL_CODE_CONTAINER", true);
    this.addChannel("CHANNEL_CODE_GEN");
    PageLoadDocsTraits.pageLoad$HideEmptyEl(this.props);
    this.hideTableIfEmpty();

    if (this.props.el$(".hljs").exists) {
      const onHighlight = () =>
        hljs.highlightElement(this.props.el$(".hljs").el);
      requestAnimationFrame(onHighlight);
    }
  }
}
